/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface LeadExchangeDestination
 */
export interface LeadExchangeDestination {
    /**
     * 
     * @type {string}
     * @memberof LeadExchangeDestination
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadExchangeDestination
     */
    name: string;
}

/**
 * Check if a given object implements the LeadExchangeDestination interface.
 */
export function instanceOfLeadExchangeDestination(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function LeadExchangeDestinationFromJSON(json: any): LeadExchangeDestination {
    return LeadExchangeDestinationFromJSONTyped(json, false);
}

export function LeadExchangeDestinationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadExchangeDestination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function LeadExchangeDestinationToJSON(value?: LeadExchangeDestination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

